<template>
	<v-menu v-model="open"
		location="start center" offset="10" :width="600"
		:disabled="jobs.length === 0"
		:content-class="{
			'v-theme--dark': darkMode,
		}"
		:close-on-content-click="false"
		no-click-animation>
		<template v-slot:activator="{ props }">
			<v-badge v-bind="props" color="#E22C3A"
				:model-value="!!jobs.length" :content="jobs.length">
				<v-icon size="30">mdi-application-cog-outline</v-icon>
			</v-badge>
		</template>
		<v-list v-if="open && jobs.length > 0" class="pa-0">
			<div class="d-flex justify-space-between">
				<v-list-subheader class="font-weight-bold">JOBS</v-list-subheader>
				<v-btn variant="plain" color="secondary" @click="clearJobs"> Clear All </v-btn>
			</div>
			<perfect-scrollbar class="ps scrollable">
				<v-expansion-panels variant="accordion" multiple>
					<template v-for="(job, index) in jobs" :key="job.JobKey">
						<v-expansion-panel v-if="job.Status && job.JobTime">
							<v-expansion-panel-title :color="jobColor(job.Status)">
								<div class="text-caption pl-2">
									{{
										`Job ${index + 1} out of ${jobs.length}. Station: ${job.StationName}. ${job.JobMessage}`
									}}
								</div>
							</v-expansion-panel-title>
							<v-expansion-panel-text>
								<v-list-item :base-color="jobColor(job.Status)">
									<template v-slot:prepend>
										<v-icon size="20" :icon="`mdi-${jobIcon(job.Status)}`"/>
									</template>
									<template v-slot:default>
										<div class="text-caption">
											{{ `Status: ${job.Status} ${!!job.Description ? '-' + job.Description: ''}` }}
										</div>
									</template>
									<template v-slot:append>
										<v-btn icon="mdi-close" size="small" variant="text"
											@click="removeJob(job.JobKey)"></v-btn>
									</template>
								</v-list-item>
							</v-expansion-panel-text>
						</v-expansion-panel>
					</template>
				</v-expansion-panels>
			</perfect-scrollbar>
		</v-list>
	</v-menu>
</template>

<script>

/* Libraries */
import _ from "lodash";

/* Enums */
import JobStatus from "@/enums/JobStatus";

export default {
	name: "JobsContainer",

	data() {
		return {
			open: false,
			jobsInterval: null
		}
	},

	computed: {
		jobs() {
			return this.$store.getters.getJobs();
		},

		jobsKeys() {
			return this.$store.getters.getJobsKeys();
		},

		darkMode() {
			return this.$store.getters.darkMode();
		}
	},

	methods: {
		jobIcon(jobStatus) {
			switch (JobStatus[jobStatus]) {
				case JobStatus.Running:
					return "progress-wrench";
				case JobStatus.Error:
				case JobStatus.K8Error:
					return "alert-circle";
				case JobStatus.Expired:
					return "close-circle";
				case JobStatus.Completed:
					return "check-circle";
			}
		},

		jobColor(jobStatus) {
			switch (JobStatus[jobStatus]) {
				case JobStatus.Ready:
				case JobStatus.Running:
					return "info";
				case JobStatus.Error:
				case JobStatus.K8Error:
					return "error";
				case JobStatus.Scheduled:
				case JobStatus.Expired:
					return "warning";
				case JobStatus.Completed:
					return "success";
			}
		},

		removeJob(jobKey) {
			this.$store.commit("removeJobByKey", jobKey);
		},

		updateJobs() {
			this.jobs.forEach(job => {
				if (![
					JobStatus.Error,
					JobStatus.K8Error,
					JobStatus.Completed,
					JobStatus.Expired,
					JobStatus.Invalid
				].includes(JobStatus[job?.Status])) {
					this.$store.dispatch("updateJobState", job)
				}
			});
		},

		clearJobs() {
			this.jobsKeys.forEach(j => {
				this.removeJob(j);
			});
		}
	},

	watch: {
		jobsKeys(keys, prevKeys) {
			if (!_.isEmpty(keys) && !this.jobsInterval) {
				if (_.isEmpty(prevKeys)) {
					this.updateJobs();
				}
				this.jobsInterval = this.$worker.setInterval(this.updateJobs, 1500)
			}
			else if (_.isEmpty(keys) && this.jobsInterval) {
				this.$worker.clearInterval(this.jobsInterval);
				this.jobsInterval = null;
			}
		}
	}
}
</script>